<div role="status" class="unsupported-state">
  <span class="unsupported-state-icon">
    <aiwyn-icon name="file" [height]="30" [width]="30" />
  </span>
  <span class="unsupported-state-title h3-500">Preview not available for this file type</span>
  <span class="unsupported-state-subtitle body-400">{{ file().name }}</span>

  @if (canDownload()) {
    <button
      dataSelector="file-preview-unsupported-download"
      type="button"
      class="unsupported-state-download"
      (click)="onDownload()"
      andButton
      color="secondary"
    >
      <aiwyn-icon name="download" [height]="18" [width]="18" />
      <span>Download</span>
    </button>
  }
</div>
